import { forwardRef } from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Slide,
  CircularProgress,
} from "@mui/material";
import { ReactComponent as LogoutIcon2 } from "../../assets/icons/logout2.svg";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../redux/reducers/auth/authService";
import { clearAuth } from "../../redux/reducers/auth/authSlice";
import { useNavigate } from "react-router-dom";
import { googleLogout } from "@react-oauth/google";
import { LoadingButton } from "@mui/lab";
import { useTranslation } from "react-i18next";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const LogoutDialog = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading } = useSelector((state) => state.auth);
  const { t } = useTranslation();

  const handleLogout = async () => {
    try {
      const providerType = localStorage.getItem("providerType");
      if (providerType === "google") {
        googleLogout();
      }

      // Dispatch logout action
      await dispatch(logout());

      dispatch(clearAuth());

      // Clear all storage and navigate
      localStorage.clear();
      sessionStorage.clear();

      onClose();
      navigate("/");
    } catch (error) {
      console.error("Logout error:", error);

      localStorage.clear();
      sessionStorage.clear();

      onClose();
      navigate("/");
    }
  };

  return (
    <Dialog
      TransitionComponent={Transition}
      keepMounted
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
    >
      <DialogContent sx={{ textAlign: "center" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              backgroundColor: "#FBE9E7",
              borderRadius: "50%",
              border: "1px solid",
              borderColor: "primary.main",
              width: 80,
              height: 80,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <LogoutIcon2 style={{ width: 30, height: 30 }} />
          </Box>
        </Box>

        <Box sx={{ mt: 2 }}>
          <Typography variant="h4" fontWeight={600}>
            {t("logout.title")}
          </Typography>
          <Typography mt={1} variant="body2" color="text.secondary">
            {t("logout.description")}
          </Typography>
        </Box>

        <LoadingButton
          fullWidth
          variant="contained"
          color="primary"
          onClick={handleLogout}
          loading={loading}
          loadingIndicator={<CircularProgress size={24} />}
          sx={{ mt: 3 }}
        >
          {t("logout.button")}
        </LoadingButton>
      </DialogContent>
    </Dialog>
  );
};

export default LogoutDialog;
